<template>
  <div v-loading="$mip('getInstructionById')" class="widget">
    <div class="widget__head">
      <h3 class="widget__title">{{ instruction.heading }}</h3>
    </div>
    <div class="widget__body">
      <div class="overflow-auto" v-html="instruction.content" />
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      instructionId: [Number, String]
    },

    data() {
      return {
        instruction: {}
      }
    },

    async created() {
      this.instruction = (await this.$http.getInstructionById(this.instructionId)).data
    }
  }
</script>
